import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/about.css';
import Slide from 'react-reveal/Slide';
import { Helmet } from 'react-helmet';

const listStyle = {
    fontSize: 22,
}

const About = () => {
    return (
        <div class="About mt-5">
                <Helmet>
                    <title>{ "PASADA | About" }</title>
                    <meta name="description" content="PASADA PH Web Application" />
                </Helmet>
            <div class="afirst mx-3 d-flex justify-content-center align-items-center">
                <div class="asecond">
                    <div class="overview-section">
                        <h1 class="mt-3 text-uppercase">Overview</h1>
                        <p>We are an AI- and IoT-powered platform that monitors and analyses real-time driving behavior 
                            of public utility vehicles. PASADA delivers data-driven insights to improve road safety, 
                            operational efficiency, and promote a smarter, safer transport system for the Philippines. 
                            It aims to enhance the skill and evaluate public utility vehicle drivers by developing 
                            software and hardware solutions.
                        </p>
                    </div>
                    {/*<p>*/}
                    {/*    PASADA will combine information communication technology (ICT) solutions to monitor and record the*/}
                    {/*    driving attitude of drivers such as their sudden acceleration, stopping, swerving, and turning.*/}
                    {/*    The project includes mobile learning applications and web based system, with gamified simulations*/}
                    {/*    and solutions to determine the truck drivers’ degree of driving knowledge.*/}
                    {/*</p>*/}
                    {/*<p>*/}
                    {/*    The results of the assessment and evaluation before and during deployment on the road will be sent*/}
                    {/*    to the cloud to be processed using artificial intelligence and data analytics. A simplified dashboard*/}
                    {/*    that reports the fleet and up to individual driver reports will be accessible through web and mobile*/}
                    {/*    applications by trucking operators.*/}
                    {/*</p>*/}
                    <div class="row pt-2">
                        <div class="col-2 d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="currentColor"
                                 className="bi bi-star-fill" viewBox="0 0 16 16">
                                <path
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                            </svg>
                        </div>
                        <div class="col-9">
                            <h4><b>Advantage</b></h4>
                            <p>PASADA integrates the latest technologies to empower public transportation services,
                                providing a learning content management system and driver performance monitoring to
                                boost road competence.</p>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-2 d-flex">
                            <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" fill="currentColor"
                                 className="bi bi-patch-check-fill" viewBox="0 0 16 16">
                                <path
                                    d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01-.622-.636zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708z"/>
                            </svg>
                        </div>
                        <div class="col-9">
                            <h4><b>Mission</b></h4>
                            <ul>
                                <li style={listStyle}>Gather and record data using an IoT device while the driver is on the road;</li>
                                <li style={listStyle}>Monitor, assess and evaluate the driving attitude of PUV drivers using Artificial
                                    Intelligence and Data Analytics; and,
                                </li>
                                <li style={listStyle}>Determine the driving knowledge of the drivers through assessment with emphasis on
                                    technical driving and vehicle roadworthiness know-how.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <img src={require('./images/aboutimg/pasada1.png')} alt="LOGO" class="aimages"/>
                </div>
            </div>

            <Slide bottom>
            <div className="firstartis d-flex justify-content-center align-items-center bg-dark text-light p-5"
                 id="systems">
                <div>
                    <img src={require('./images/learningsystems.png')} alt="LOGO" className="aimages"/>
                </div>
                <div className="secondarti p-5 m-5">
                    <h1 className="text-uppercase">Learning Systems</h1>
                    <h4>PASADA will provide learning modules in the form of games through a mobile application. These
                        learning modules will tackle basic driving skills, road signs and traffic rules knowledge, and driving
                        simulation modules and will be used for the initial process and will determine if a driver is competent to
                        be on the road. It will also provide drivers and their operators with a web-based system where they
                        can sign up.
                    </h4>
                </div>
            </div>
            </Slide>

            <Slide bottom>
            <div className="firstarti d-flex justify-content-center align-items-center bg-light text-dark p-5"
                 id="internet">
                <div className="secondarti p-5 m-5">
                    <h1 className="text-uppercase">IoT Devices</h1>
                    <h4>The IoT devices such as the camera and the gyroscope will be used to monitor the environment
                        outside the bus and jeepney and the behaviour of the driver on the road. It will give us insight
                        on certain scenarios like when a driver gets into an accident, these IoT devices will get the
                        data that is monitored by the IoT devices and store it to our cloud database. The data gathered
                        can now be used to identify the cause of the accident.
                    </h4>
                </div>
                <div>
                    <img src={require('./images/iot.png')} alt="LOGO" className="aimages"/>
                </div>
            </div>
            </Slide>

            <Slide bottom>
            <div className="firstartis d-flex justify-content-center align-items-center bg-dark text-light p-5"
                 id="dataanalytics">
                <div>
                    <img src={require('./images/dataanalytics.png')} alt="LOGO" className="aimages"/>
                </div>
                <div className="secondarti p-5 m-5">
                    <h1 className="text-uppercase">Data Analytics</h1>
                    <h4>The results from the learning modules will be used to determine whether a driver is competent
                        enough to continue driving bus and public utility jeepney or a driver lack the skills and is unfit to
                        drive a bus or public utility jeepney and must be re-educated, re-trained, re-oriented again. The data gathered
                        from the IoT devices will also be used in Data Analytics. It will show the factors and variables that
                        caused the accident on the road i.e. the speed of the bus or public utility jeepney, the weather condition,
                        the location, and etc.
                    </h4>
                </div>
            </div>
            </Slide>

            <Slide>
            <div className="firstarti d-flex justify-content-center align-items-center bg-light text-dark p-5" id="ai">
                <div className="secondarti p-5 m-5">
                    <h1 className="text-uppercase">Artificial Intelligence</h1>
                    <h4>PASADA shall implement AI Model to bus and public utility jeepney that machines can alleviate
                        that pinch point by increasing speed and productivity while reducing errors and increasing
                        consistency. It helps the drivers to load matching and route optimization which the prime examples of how
                        computers draw information from multiple internal and external sources to find patterns that humans might
                        not be able to detect. AI systems can optimize a variety of transportation operations, but they
                        can’t do it all. Humans are simply better at recognizing and attending to matters that involve emotions,
                        which are more prevalent in transportation than meets the eye, experts said.
                    </h4>
                </div>
                <div>
                    <img src={require('./images/ai.png')} alt="LOGO" className="aimages"/>
                </div>
            </div>
            </Slide>

        </div>
    );
}

export default About;